import '@babel/polyfill'
import ReactDOM from "react-dom";
import react, { PureComponent } from "react";
import { ajax } from '../libs/ajax';
import Survey from './components/survey';
import SurveyForm from "./components/surveyform";
import { SurveyContext } from './surveycontext';
import style from './survey.less';
import { isEqual } from 'lodash';

const modules = {
    'Survey': Survey,
    'SurveyForm': SurveyForm
}

class SurveyApp extends PureComponent {
    constructor(props) {
        super(props);

        this.fetchSurvey = this.fetchSurvey.bind(this);
        this.submitAnswer = this.submitAnswer.bind(this);
        this.submitSurveyForm = this.submitSurveyForm.bind(this);
        this.getCurrentQuestion = this.getCurrentQuestion.bind(this);
        this.getSurveyResultAsync = this.getSurveyResultAsync.bind(this);
    }

    state = {
        survey: null,
        currentQuestion: null,
        displaySurveyForm: false,
        answers: [],
        screen: 'Survey'
    }

    componentDidMount() {
        this.fetchSurvey();
    }

    async fetchSurvey() {
        const { config } = this.props;
        const survey = await ajax({
            url: `/umbraco/api/survey/get?surveyId=${config.surveyId}`
        });

        this.setState({ 'survey': survey.data, 'currentQuestion': survey.data.questions[0] });
    }

    async submitAnswer(answer) {
        const { answers, survey, currentQuestion } = this.state;
        const { config } = this.props;
        answers.push(answer);

        var index = survey.questions.indexOf(currentQuestion);
        var isLast = survey.questions.length - 1 == index;

        var surveyForm = {
            'answers': answers,
            surveyId: config.surveyId
        }

        if (isLast) {
            this.setState({ 'screen': 'SurveyForm' });
        }

        var nextQuestion = survey.questions[survey.questions.indexOf(currentQuestion) + 1];
        this.setState({ 'currentQuestion': nextQuestion });

        $('#surveytext').hide();
    }

    getCurrentQuestion = () => {
        const { currentQuestion } = this.state;
        return currentQuestion;
    }

    async getSurveyResultAsync() {
        const { config } = this.props;
        const surveyResultModel = {
            surveyId: config.surveyId,
            answers: this.state.answers
        };

        const surveyResult = await ajax({
            url: `/umbraco/api/survey/getsurveyresult`,
            type: 'POST',
            data: JSON.stringify(surveyResultModel),
            dataType: 'json',
            contentType: 'application/json'
        });

        return surveyResult.data;
    }

    async submitSurveyForm(surveyForm) {
        const { answers } = this.state;
        const { config } = this.props;
        
        surveyForm.answers = answers;
        surveyForm.surveyId = config.surveyId;

        return ajax({
            url: `/umbraco/api/survey/post`,
            type: 'POST',
            data: JSON.stringify(surveyForm),
            dataType: 'json',
            contentType: 'application/json'
        }).then((result) => {
            document.location = result.data;
        });
        
    }

    render() {
        const { currentQuestion, survey, screen } = this.state;
        const ModuleComponent = modules[screen];

        return (
            this.state.survey &&
            <SurveyContext.Provider value={{
                submitAnswer: this.submitAnswer,
                submitSurveyForm: this.submitSurveyForm,
                getCurrentQuestion: this.getCurrentQuestion,
                getSurveyResultAsync: this.getSurveyResultAsync
            }}>
                <div className="ui form">
                    <ModuleComponent />
                </div>
            </SurveyContext.Provider>
        );
    }
}

const appContainer = document.getElementById("react-app");
const surveyConfig = window.SurveyConfig;

ReactDOM.render(<SurveyApp config={surveyConfig} />, appContainer);